<div class="mat-modal-dialog cloneTrip-modal">
    <h2 mat-dialog-title>
        <mat-icon style="color:red; float: right; cursor: pointer; position: relative; top: 7px;"
            (click)=" this.dialogRef.close()">close</mat-icon>
    </h2>
    <mat-dialog-content style="position: relative; bottom: 10px;">
        <span class="material-icons-outlined"
            style="color: #FF0000; font-size: 19px; position: relative; top: 5px; margin-right: 10px;">
            info</span> <span style="color: #FF455B; font-size: 14px; font-weight: 500; font-family: poppins;">Clone
            trips for future dates.</span>
    </mat-dialog-content>

    <mat-dialog-content style="position: relative; bottom: 10px;">
        <div class="row">
            <div class="col-sm-8">
                <form [formGroup]="_mFormGroup">
                    <label style="color: #212529;">To Date <sup class="mandatory">*</sup></label>
                    <mat-form-field appearance="outline" class="cloneDateSelector">
                        <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker1"
                            (click)="picker1.open()" readonly placeholder="To Date" formControlName="toDate">
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                            <img matDatepickerToggleIcon src="assets/images/bx-calendar.svg">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </form>
            </div>
        </div>
    </mat-dialog-content>

    <div mat-dialog-actions align="end" style="position: relative; right: 15px;">
        <button type="button" class="btn red-btn-solid" (click)="onConfirmation()">Submit</button>
    </div>
</div>